enum ECodificacao {
  Indefinido = '',
  TemaAdministrativo = 'TEMA_ADMINISTRATIVO',
  TemaVendas = 'TEMA_VENDAS',
  TemaFinanceiro = 'TEMA_FINANCEIRO',
  SubtemaMetaVendas = 'SUBTEMA_META_VENDAS',
  TemaEstoque = 'TEMA_ESTOQUE',
  SubtemaPedidoCompra = 'SUBTEMA_PEDIDO_COMPRA',
}

export default ECodificacao;
